import React, { Component } from 'react'
import PropTypes from 'prop-types'

class PostForm extends Component {
  componentDidMount () {
    this._form.submit()
  }

  render () {
    return (
      <form
        method='post'
        action={this.props.action}
        id='formid'
        ref={c => (this._form = c)}
      >
        {this.props.parameters.map((item, ix) => {
          var value = item.split('=')

          return (
            <input
              key={ix}
              type='hidden'
              name={value[0]}
              value={value[0] === 'token' ? this.props.token : value[1]}
            />
          )
        })}
      </form>
    )
  }
}

PostForm.propTypes = {
  action: PropTypes.string,
  token: PropTypes.string,
  parameters: PropTypes.array
}

export default PostForm



// WEBPACK FOOTER //
// ./src/features/Redirect/PostForm.js